const skus = ["20498", "20499", "21021", "21135", "21136", "21139", "21140", "21141", "21142", "21143", "21144", "21145", "21146", "21147", "21148", "21151", "21152", "21221", "21223", "21226", "21227", "21229", "21277", "21282", "21283", "21284"]
/**@param {string}sku */
export const isOnlyProfessional = (sku) => {
  const searchSku = skus.filter(skuInList => sku == skuInList);
  if (searchSku.length > 0) {
    return true;
  } else {
    return false;
  }
};
